import type { ReactNode } from 'react'

import { ScrollArea } from '@/components/ui/scroll-area'
import { cn } from '@/lib/utils'

import { SettingsLayoutMobileHeader } from './settings-layout-mobile-header.atom'
import { SettingsLayoutMobileSheet } from './settings-layout-mobile-sheet.atom'
import type { SettingsNavGroup, SettingsNavItem } from './settings-nav-item.interface'

interface SettingsLayoutMobileProps {
  groupList: SettingsNavGroup[]
  activeItemId: string
  onItemClick: (item: SettingsNavItem) => void
  children: ReactNode
  sidebarTitle?: string
  contentTitle?: string
  contentDescription?: string
  className?: string
  isMobileMenuOpen: boolean
  onMobileMenuOpenChange: (open: boolean) => void
}

export const SettingsLayoutMobile = ({
  groupList,
  activeItemId,
  onItemClick,
  children,
  sidebarTitle,
  contentTitle,
  contentDescription,
  className,
  isMobileMenuOpen,
  onMobileMenuOpenChange,
}: SettingsLayoutMobileProps): ReactNode => (
  <div className={cn('settings-layout settings-layout--mobile flex h-full flex-col', className)}>
    <SettingsLayoutMobileHeader
      contentTitle={contentTitle}
      contentDescription={contentDescription}
      onMenuOpen={() => onMobileMenuOpenChange(true)}
    />
    <SettingsLayoutMobileSheet
      groupList={groupList}
      activeItemId={activeItemId}
      onItemClick={onItemClick}
      sidebarTitle={sidebarTitle}
      isOpen={isMobileMenuOpen}
      onOpenChange={onMobileMenuOpenChange}
    />
    <ScrollArea className="settings-layout-content min-h-0 flex-1">
      <div className="p-4">{children}</div>
    </ScrollArea>
  </div>
)
